import { render } from "./Contacts.vue?vue&type=template&id=2f814a4c&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=2f814a4c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f814a4c"],['__file',"src/assets/js/pages/AddIntercom/Contacts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f814a4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f814a4c', __exports__)) {
    api.reload('2f814a4c', __exports__)
  }
  
  module.hot.accept("./Contacts.vue?vue&type=template&id=2f814a4c&scoped=true", () => {
    api.rerender('2f814a4c', render)
  })

}


export default __exports__